import React, { FC, memo } from 'react';
import { useField } from 'formik';

import usePrefix from 'utils/usePrefix';
import FormDescription from 'components/ResqlExpert/FormDescription';
import {
  FormSectionStyled,
  TabBodyContentStyled,
} from 'components/ResqlExpert/SubmissionForm/styles';

import ExpertNote from '../ExpertNote';

const Retrospective: FC = () => {
  const t = usePrefix('ResqlExpert');
  const [shortTermField] = useField<string>('short_term_objectives');
  const [longTermField] = useField<string>('long_term_objectives');
  const [commentShortTermField, , commentShortTermHelpers] = useField<string>('comment_short_term_objectives');
  const [commentLongTermField, , commentLongTermHelpers] = useField<string>('comment_long_term_objectives');

  return (
    <TabBodyContentStyled>
      <FormSectionStyled>
        <FormDescription title={t('tab_goals')}>
          <p>{t('tab_goals_hint')}</p>
        </FormDescription>
        <p>
          <strong>{t('tab_goals_short_term')}</strong>
        </p>
        {shortTermField.value ? <p>{shortTermField.value}</p> : null}
        <ExpertNote
          id="expert-note-goals-short-term"
          label={t('tab_goals_short_term')}
          value={commentShortTermField.value ?? ''}
          onChange={(v) => commentShortTermHelpers.setValue(v)}
        />
        <p>
          <strong>{t('tab_goals_long_term')}</strong>
        </p>
        {longTermField.value ? <p>{longTermField.value}</p> : null}
        <ExpertNote
          id="expert-note-goals-long-term"
          label={t('tab_goals_long_term')}
          value={commentLongTermField.value ?? ''}
          onChange={(v) => commentLongTermHelpers.setValue(v)}
        />
      </FormSectionStyled>
    </TabBodyContentStyled>
  );
};

export default memo(Retrospective);
